import { useMediaQuery } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import NoDataIcon from "../../../assets/no_data.png";

interface NotFoundProps {
  readonly message?: string;
  readonly showIcon?: boolean;
}

export function NotFound({ message, showIcon = false }: Readonly<NotFoundProps>) {
  const isMobile = useMediaQuery("(max-width:700px)");

  return (
    <Stack
      spacing={4}
      sx={{
        display: "flex",
        alignItems: "center",
        mt: 6,
      }}
    >
      {showIcon && <img src={NoDataIcon} alt="No Data Icon" style={{ width: "15vw" }} />}
      <Typography
        variant="h1"
        sx={{
          mb: 3,
          fontWeight: 500,
        }}
      >
        No insights found
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{
          mb: 3,
          fontWeight: 400,
          maxWidth: isMobile ? "none" : "70%",
        }}
      >
        {message ?? "We're sorry, but we couldn't find any relevant insights with the selected filters."}
      </Typography>
    </Stack>
  );
}
